module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-timber-balmoral-0.85208851.jpg";